import { withRBAC } from "../../rbac";
import { LeaveRequestCreate } from "./Create";
import { LeaveRequestList } from "./List";
import { LeaveRequestShow } from "./Show";

export const leaveRequests = {
  list: withRBAC(LeaveRequestList, "view_hr"),
  show: withRBAC(LeaveRequestShow, "view_hr"),
  create: withRBAC(LeaveRequestCreate, "view_hr"),
};
